import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod'

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_CONVEX_URL: z.url(),
    VITE_CONVEX_SITE_URL: z.url(),
    VITE_TURNSTILE_SITE_KEY: z.string(),
    VITE_LIVEKIT_WS_URL: z.string().url(),
    VITE_POSTHOG_PROJECT_TOKEN: z.string().optional(),
    VITE_POSTHOG_HOST: z.url().optional(),
    VITE_GTM_ID: z.string().optional(),
    VITE_SENTRY_DSN: z.url().optional(),
    VITE_SUPPORT_EMAIL: z.string().email().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
})
